<template>
  <div class="userinfo">
    <headd :mobile_title="mobile_title"></headd>

    <div class="user_index container">
      <div class="user_head hidden-xs">
        <div class="head_set" @click="goset">
          <img :src="imgURL + 'user/icon_3.png'" />
        </div>
        <div class="head_info">
          <div class="headi">
            <div class="avtar" @click="goset">
              <img
                :src="
                  userinfo.avatarUrl != ''
                    ? userinfo.avatarUrl
                    : imgURL + 'user/icon_1.png'
                "
              />
            </div>
            <div class="info">
              <div class="name">{{ userinfo.nickname }}</div>
              <div class="mobile">
                <div class="m_icon">
                  <img :src="imgURL + 'user/icon_2.png'" />
                </div>
                {{ userinfo.username }}
              </div>
            </div>
          </div>
          <div class="head_type">
            <div class="type_name">
              <div class="name_icon">
                <img :src="imgURL + 'user/icon_4_2.png'" />
              </div>
              <span v-if="userinfo.user_type == '1'">成为服务商</span>
              <span v-else-if="userinfo.user_type == '2'">销售</span>
              <span v-else-if="userinfo.user_type == '3'">客服</span>
              <span v-else-if="userinfo.user_type == '4'">财务</span>
              <span v-else-if="userinfo.user_type == '5'">外勤</span>
              <span v-else-if="userinfo.user_type == '6'">服务商</span>
              <span v-else-if="userinfo.user_type == '7'">法务</span>
              <span v-else-if="userinfo.user_type == '8'">设计师</span>
            </div>
            <div
              class="type_more"
              @click="goSettled"
              v-if="userinfo.user_type == '1'"
            >
              立即查看
            </div>
          </div>
        </div>
        <div class="head_tab">
          <div class="tab_title">我的钱包</div>
          <div class="tab_item" @click="gorecharge">
            <div class="tab_count">{{ userinfo.balance }}</div>
            <div class="tab_name">现金余额（元）</div>
          </div>
          <div class="tab_item" @click="gocoupon">
            <div class="tab_count">{{ userinfo.couponNum }}</div>
            <div class="tab_name">优惠券（个）</div>
          </div>
        </div>
      </div>

      <div class="user_head hidden-lg">
        <div class="head_set" @click="goset">
          <img :src="imgURL + 'user/icon_3.png'" />
        </div>
        <div class="head_info">
          <div class="avtar" @click="goset">
            <img
              :src="
                userinfo.avatarUrl != ''
                  ? userinfo.avatarUrl
                  : imgURL + 'user/icon_1.png'
              "
            />
          </div>
          <div class="info">
            <div class="name">{{ userinfo.nickname }}</div>
            <div class="mobile">
              <div class="m_icon">
                <img :src="imgURL + 'user/icon_2.png'" />
              </div>
              {{ userinfo.username }}
            </div>
          </div>
        </div>
        <div class="head_tab">
          <div class="tab_item" @click="gorecharge">
            <div class="tab_count">{{ userinfo.balance }}</div>
            <div class="tab_name">现金余额（元）</div>
          </div>
          <div class="tab_item" @click="gocoupon">
            <div class="tab_count">{{ userinfo.couponNum }}</div>
            <div class="tab_name">优惠券（个）</div>
          </div>
        </div>
        <div class="head_type">
          <div class="type_name">
            <div class="name_icon">
              <img :src="imgURL + 'user/icon_4_2.png'" />
            </div>
            <span v-if="userinfo.user_type == '1'">成为服务商</span>
            <span v-else-if="userinfo.user_type == '2'">销售</span>
            <span v-else-if="userinfo.user_type == '3'">客服</span>
            <span v-else-if="userinfo.user_type == '4'">财务</span>
            <span v-else-if="userinfo.user_type == '5'">外勤</span>
            <span v-else-if="userinfo.user_type == '6'">服务商</span>
            <span v-else-if="userinfo.user_type == '7'">法务</span>
            <span v-else-if="userinfo.user_type == '8'">设计师</span>
          </div>
          <div
            class="type_more"
            @click="goSettled"
            v-if="userinfo.user_type == '1'"
          >
            立即查看
          </div>
        </div>
      </div>
      <div
        class="index-banner"
        v-if="userinfo.user_type == '1'"
        @click="gotwitter"
      >
        <img src="../../../../static/user/icon_14.png" mode="widthFix" />
      </div>
      <div
        class="index-banner"
        v-if="userinfo.user_type == '6'"
        @click="gotwitter"
      >
        <img src="../../../../static/user/icon_15.png" mode="widthFix" />
      </div>
      <div class="row">
        <div class="col-lg-7">
          <div
            class="box_con mt20"
            v-if="userinfo.user_type == '1' || userinfo.user_type == '6'"
          >
            <div class="box_title">
              我的订单
              <!-- <div class="more" @click="goorderlist(1)">查看更多</div> -->
            </div>
            <div class="order_status">
              <div class="status_item" @click="goorderlist(2)">
                <div class="item_icon">
                  <img :src="imgURL + 'user/icon_5_1.png'" />
                  <div class="tip" v-if="userinfo.unpay_num > 0">
                    {{ userinfo.unpay_num | indexsum}}
                  </div>
                </div>
                <div class="item_name">待付款</div>
              </div>
              <div class="status_item" @click="goorderlist(3)">
                <div class="item_icon">
                  <img :src="imgURL + 'user/icon_5_5.png'" />
                  <div class="tip" v-if="userinfo.pending_num > 0">
                    {{ userinfo.pending_num | indexsum}}
                  </div>
                </div>
                <div class="item_name">待处理</div>
              </div>
              <div class="status_item" @click="goorderlist(4)">
                <div class="item_icon">
                  <img :src="imgURL + 'user/icon_5_2.png'" />
                  <div class="tip" v-if="userinfo.processing_num > 0">
                    {{ userinfo.processing_num | indexsum}}
                  </div>
                </div>
                <div class="item_name">办理中</div>
              </div>
              <div class="status_item" @click="goorderlist(5)">
                <div class="item_icon">
                  <img :src="imgURL + 'user/icon_5_3.png'" />
                  <div class="tip" v-if="userinfo.success_num > 0">
                    {{ userinfo.success_num  | indexsum}}
                  </div>
                </div>
                <div class="item_name">已完结</div>
              </div>
              <div class="status_item" @click="goorderlist(1)">
                <div class="item_icon">
                  <img :src="imgURL + 'user/icon_5_4.png'" />
                </div>
                <div class="item_name">全部订单</div>
              </div>
            </div>
          </div>
          <div
            class="box_con mt20 hidden-lg hidden-md"
            v-if="userinfo.user_type == '1' || userinfo.user_type == '6'"
          >
            <div class="box_title">
              常用功能
            </div>
            <div class="module_list">
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_1.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">公司核名</div>
                  </div>
                </div>
                <div
                  class="item_btn"
                  @click="golink('http://www.gsxt.gov.cn/index.html')"
                >
                  点击查看
                </div>
              </div>
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_2.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      记账申报
                      <div
                        class="span"
                        @click="addreport"
                        v-if="
                          userinfo.user_type == '4' || userinfo.user_type == '6'
                        "
                      >
                        立即申报
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="report">点击查看</div>
              </div>
              <div class="module_item">
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_3.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      资料寄送
                      <div class="span" @click="adddelivery">立即寄送</div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="delivery">点击查看</div>
              </div>
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_4.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      代开票申请
                      <div
                        v-if="
                          userinfo.user_type == '1' || userinfo.user_type == '6'
                        "
                        class="span"
                        @click="addinvoice"
                      >
                        申请开票
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="record">点击查看</div>
              </div>
            </div>
          </div>
          <div
            class="box_con mt20 hidden-lg hidden-md"
            v-if="userinfo.user_type == '1' || userinfo.user_type == '6'"
          >
            <div class="box_title">
              常用工具
            </div>
            <div class="tool_list">
              <div
                class="tool_item"
                @click="golink('http://sbj.cnipa.gov.cn/sbcx/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_1.png'" />
                </div>
                <div class="tool_name">商标查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('http://cpquery.cnipa.gov.cn/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_2.png'" />
                </div>
                <div class="tool_name">专利查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('https://register.ccopyright.com.cn/query.html')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_3.png'" />
                </div>
                <div class="tool_name">著作权查询</div>
              </div>
              <div
                class="tool_item"
                @click="
                  golink(
                    'http://shanghai.chinatax.gov.cn/newxbwz/wzfw/yihushi.jsp'
                  )
                "
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_4.png'" />
                </div>
                <div class="tool_name">税务查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('https://m.kuaidi100.com/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_5.png'" />
                </div>
                <div class="tool_name">快递查询</div>
              </div>
            </div>
          </div>
          <div>
            <div class="box_con" v-if="userinfo.user_type == '1'">
              <div class="info_data ">
                <div class="data_head">
                  <div class="data_title">
                    <div class="line"></div>
                    法务咨询服务
                  </div>
                  <div class="data_right">
                    剩余 {{ userinfo.leftDays }} 天
                    <div class="right" @click="goaffairs">续费</div>
                  </div>
                </div>
                <div class="data_cell_list mt35">
                  <div class="data_cell">
                    <div class="cell_title">服务期限</div>
                    <div class="cell_con">{{ userinfo.expiredAt }} 到期</div>
                  </div>
                  <div class="data_cell" v-if="userinfo.fwservice_file">
                    <div class="cell_title">服务合同</div>
                    <div
                      class="cell_con"
                      @click="goView(userinfo.fwservice_file)"
                      style="cursor: pointer;"
                    >
                      下载
                    </div>
                  </div>
                </div>
              </div>

              <div class="btn_list mt35 mb35">
                <div class="bbtn btnzx" @click="kefu(userinfo.recipient_id)">
                  法务咨询
                </div>
              </div>
            </div>
          </div>
          <div v-if="userinfo.designlogo != ''">
            <div class="box_con" v-if="userinfo.user_type == '1'">
              <div class="info_data">
                <div class="data_head">
                  <div class="data_title">
                    <div class="line"></div>
                    设计LOGO
                  </div>
                  <div class="data_right" @click="gologolist()">更多 ></div>
                
                </div>
                <div class="data_cell_list mt35">
                  <div class="data_cell">
                    <div class="cell_title">设计师</div>
                    <div class="cell_con">
                      {{ userinfo.designlogo.designer }}
                    </div>
                  </div>
                  <div class="data_cell">
                    <div class="cell_title">需求描述</div>
                    <div
                      class="cell_con"
                      v-html="userinfo.designlogo.design_desc"
                    ></div>
                  </div>
                  <div class="data_cell">
                    <div class="cell_title">状态</div>
                    <div class="cell_con">
                      {{ userinfo.designlogo.design_status }}
                    </div>
                  </div>
                  <div class="data_cell">
                    <div class="cell_title">订单</div>
                    <div class="cell_con">
                      {{ userinfo.designlogo.design_leixing }}  {{userinfo.designlogo.design_paynum}}
                    </div>
                  </div> 

                  <div class="data_cell" v-if="userinfo.designlogo.imgpath">
                    <div class="cell_title">logo图片</div>
                    <div class="cell_con dlogo">
                      <div
                        class="logoimg"
                        :style="{
                          backgroundImage:
                            'url(' + userinfo.designlogo.imgpath + ')'
                        }"
                      >
                        <img
                          :src="userinfo.designlogo.imgpath"
                          mode="widthFix"
                        />
                      </div>
                      <div
                        class="item_btn"
                        @click="goView_image(userinfo.designlogo.imgpath)"
                      >
                        下载
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="btn_list">
                <div
                  class="bbtn btnzx"
                  @click="kefu(userinfo.designlogo.recipient_id)"
                >
                  设计师咨询
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              userinfo.companys != undefined && userinfo.companys.length > 0
            "
          >
            <div
              class="box_con"
              v-if="userinfo.user_type == '1' || userinfo.user_type == '6'"
            >
              <div class="box_title ">
                我的公司
                <!-- <view class="more">查看更多</view> -->
              </div>
              <div v-for="(item, index) in userinfo.companys" :key="index">
                <div class="info_data mt20 m30">
                  <div class="data_head">
                    <div class="data_title">
                      <div class="line"></div>
                      {{ item.company_title }}
                    </div>
                    <!-- <view class="data_right">剩余 {{item.leftDays}} 天 <view class="right">续费</view> 
						</view>-->
                  </div>
                  <div class="data_sn">
                    统一社会信用代码：{{ item.credit_code }}
                  </div>
                  <s-tabs @change="change">
                    <s-tab title="基本信息">
                      <div class="data_cell_list ">
                        <div class="data_cell">
                          <div class="cell_title">法定代表人</div>
                          <div class="cell_con">{{ item.legal_person }}</div>
                        </div>
                        <div class="data_cell">
                          <div class="cell_title">成立日期</div>
                          <div class="cell_con">{{ item.setuptime }}</div>
                        </div>
                        <div class="data_cell">
                          <div class="cell_title">注册资本</div>
                          <div class="cell_con">
                            {{ item.register_capital }}
                          </div>
                        </div>
                        <div class="data_cell">
                          <div class="cell_title">企业类型</div>
                          <div class="cell_con">{{ item.company_type }}</div>
                        </div>
                        <div class="data_cell">
                          <div class="cell_title">营业期限</div>
                          <div class="cell_con">
                            {{ item.operating_period }}
                          </div>
                        </div>
                        <div class="data_cell">
                          <div class="cell_title">登记机关</div>
                          <div class="cell_con">
                            {{ item.register_authority }}
                          </div>
                        </div>
                        <div class="data_cell">
                          <div class="cell_title">注册地址</div>
                          <div class="cell_con">
                            {{ item.register_address }}
                          </div>
                        </div>
                        <div class="data_cell">
                          <div class="cell_title">经营范围</div>
                          <div class="cell_con">{{ item.business_scope }}</div>
                        </div>
                      </div>
                    </s-tab>
                    <s-tab title="股东信息">
                      <div class="data_table_list ">
                        <div class="table_head">
                          <div class="head_25">姓名</div>
                          <div class="head_50">身份证号</div>
                          <div class="head_25">持股比例</div>
                        </div>
                        <div
                          class="table_li"
                          v-for="(item2, index) in JSON.parse(
                            item.shareholder_info
                          )"
                          :key="index"
                        >
                          <div class="head_25">
                            {{ item2.shareholder_name }}
                          </div>
                          <div class="head_50">
                            {{ item2.shareholder_idno }}
                          </div>
                          <div class="head_25">
                            {{ item2.shareholder_precent }}
                          </div>
                        </div>
                      </div>
                    </s-tab>
                    <s-tab title="证照下载">
                      <div class="data_img">
                        <div class="img_item" v-if="item.license_img">
                          <img :src="item.license_img" mode="widthFix" />
                          <div
                            class="item_btn"
                            @click="goView_image(item.license_img)"
                          >
                            下载
                          </div>
                        </div>
                        <!-- <image :src="item.license_img" mode="widthFix"></image> -->
                      </div>
                    </s-tab>
                  </s-tabs>
                </div>

                <div class="info_data mt35" v-if="item.is_service == '1'">
                  <div class="data_head">
                    <div class="data_title">
                      <div class="line"></div>
                      代理记账服务
                    </div>
                    <div class="data_right">
                      剩余 {{ item.leftDays }} 天
                      <div class="right" @click="goagency">续费</div>
                    </div>
                  </div>
                  <div class="data_cell_list mt35">
                    <div class="data_cell">
                      <div class="cell_title">服务期限</div>
                      <div class="cell_con">{{ item.expiredAt }} 到期</div>
                    </div>
                    <div class="data_cell" v-if="item.service_file">
                      <div class="cell_title">服务合同</div>
                      <div
                        class="cell_con"
                        @click="goView(item.service_file)"
                        style="cursor: pointer;"
                      >
                        下载
                      </div>
                    </div>
                    <div class="data_cell" v-if="item.main_business">
                      <div class="cell_title">主营业务</div>
                      <div class="cell_con">{{ item.main_business }}</div>
                    </div>
                    <div class="data_cell" v-if="item.approved_tax">
                      <div class="cell_title">核定的税种</div>
                      <div class="cell_con">{{ item.approved_tax }}</div>
                    </div>
                  </div>
                </div>

                <!-- <view>财务咨询{{item.recipient_id}}</view> -->

                <div class="btn_list mt35 mb35">
                  <div class="bbtn btnzx" @click="kefu(item.recipient_id)">
                    财务咨询
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="userinfo.user_type">
            <div class="box_con mt20" v-if="userinfo.user_type != '1'">
              <div class="box_title">
                服务功能
                <!-- <view class="more" @click="goOrdermange">查看更多</view> -->
              </div>
              <div class="service mt20">
                <div class="service_item" @click="goOrderManage('reg')">
                  <div class="item_head">
                    <img
                      class="head_icon"
                      :src="imgURL + 'order/icon_type_1.png'"
                    />
                    公司注册订单
                  </div>
                  <div class="item_con">
                    {{ userinfo.regnum1 }}/{{ userinfo.regnum2 }}
                  </div>
                </div>
                <div class="service_item" @click="goOrderManage('jizhang')">
                  <div class="item_head">
                    <img
                      class="head_icon"
                      :src="imgURL + 'order/icon_type_2.png'"
                    />

                    代理记账订单
                  </div>
                  <div class="item_con">
                    {{ userinfo.jizhangnum1 }}/{{ userinfo.jizhangnum2 }}
                  </div>
                </div>
                <div class="service_item" @click="goOrderManage('shangbiao')">
                  <div class="item_head">
                    <img
                      class="head_icon"
                      :src="imgURL + 'order/icon_type_3.png'"
                    />

                    商标注册订单
                  </div>
                  <div class="item_con">
                    {{ userinfo.shangbiaonum1 }}/{{ userinfo.shangbiaonum2 }}
                  </div>
                </div>
                <div
                  class="service_item"
                  @click="goOrderManage('zhishichanquan')"
                >
                  <div class="item_head">
                    <img
                      class="head_icon"
                      :src="imgURL + 'order/icon_type_4.png'"
                    />
                    知识产权订单
                  </div>
                  <div class="item_con">
                    {{ userinfo.zscqnum1 }}/{{ userinfo.zscqnum2 }}
                  </div>
                </div>
                <div class="service_item" @click="goOrderManage('xukezheng')">
                  <div class="item_head">
                    <img
                      class="head_icon"
                      src="../../../../static/order/icon_type_6.png"
                    />
                    许可证订单
                  </div>
                  <div class="item_con">
                    {{ userinfo.xukezhengnum1 }}/{{ userinfo.xukezhengnum2 }}
                  </div>
                </div>
                <div class="service_item" @click="goOrderManage('yiliaoqixie')">
                  <div class="item_head">
                    <img
                      class="head_icon"
                      src="../../../../static/order/icon_type_7.png"
                    />

                    医疗器械订单
                  </div>
                  <div class="item_con">
                    {{ userinfo.ylqxnum1 }}/{{ userinfo.ylqxnum2 }}
                  </div>
                </div>
                <div
                  class="service_item"
                  @click="goservice"
                  v-if="userinfo.companynum > 0 && userinfo.user_type == '4'"
                >
                  <div class="item_head">
                    <img
                      class="head_icon"
                      :src="imgURL + 'order/icon_type_5.png'"
                    />

                    服务的公司
                  </div>
                  <div class="item_con">{{ userinfo.companynum }}</div>
                </div>
                <div
                  class="service_item"
                  @click="gofwzx"
                  v-if="userinfo.user_type == '7'"
                >
                  <div class="item_head">
                    <div class="head_icon">
                      <img :src="imgURL + 'order/icon_type_5.png'" />
                    </div>
                    服务的客户
                  </div>
                  <div class="item_con">{{ userinfo.fwzxnum }}</div>
                </div>
                <div
                  class="service_item"
                  @click="gologo"
                  v-if="userinfo.user_type == '8'"
                >
                  <div class="item_head">
                    <div class="head_icon">
                      <img :src="imgURL + 'order/icon_type_5.png'" />
                    </div>
                    服务的客户
                  </div>
                  <div class="item_con">{{ userinfo.logodesignnum }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="box_con mt20 hidden-lg hidden-md"
            v-if="
              userinfo.user_type == '2' ||
                userinfo.user_type == '3' ||
                userinfo.user_type == '4' ||
                userinfo.user_type == '5' ||
                userinfo.user_type == '7' ||
                userinfo.user_type == '8'
            "
          >
            <div class="box_title">
              常用功能
            </div>
            <div class="module_list">
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_1.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">公司核名</div>
                  </div>
                </div>
                <div
                  class="item_btn"
                  @click="golink('http://www.gsxt.gov.cn/index.html')"
                >
                  点击查看
                </div>
              </div>
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_2.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      记账申报
                      <div
                        class="span"
                        @click="addreport"
                        v-if="
                          userinfo.user_type == '4' || userinfo.user_type == '6'
                        "
                      >
                        立即申报
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="report">点击查看</div>
              </div>
              <div class="module_item">
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_3.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      资料寄送
                      <div class="span" @click="adddelivery">立即寄送</div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="delivery">点击查看</div>
              </div>
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_4.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      代开票申请
                      <div
                        v-if="
                          userinfo.user_type == '1' || userinfo.user_type == '6'
                        "
                        class="span"
                        @click="addinvoice"
                      >
                        申请开票
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="record">点击查看</div>
              </div>
            </div>
          </div>
          <div
            class="box_con mt20 hidden-lg hidden-md"
            v-if="
              userinfo.user_type == '2' ||
                userinfo.user_type == '3' ||
                userinfo.user_type == '4' ||
                userinfo.user_type == '5' ||
                userinfo.user_type == '7' ||
                userinfo.user_type == '8'
            "
          >
            <div class="box_title">
              常用工具
            </div>
            <div class="tool_list">
              <div
                class="tool_item"
                @click="golink('http://sbj.cnipa.gov.cn/sbcx/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_1.png'" />
                </div>
                <div class="tool_name">商标查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('http://cpquery.cnipa.gov.cn/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_2.png'" />
                </div>
                <div class="tool_name">专利查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('https://register.ccopyright.com.cn/query.html')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_3.png'" />
                </div>
                <div class="tool_name">著作权查询</div>
              </div>
              <div
                class="tool_item"
                @click="
                  golink(
                    'http://shanghai.chinatax.gov.cn/newxbwz/wzfw/yihushi.jsp'
                  )
                "
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_4.png'" />
                </div>
                <div class="tool_name">税务查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('https://m.kuaidi100.com/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_5.png'" />
                </div>
                <div class="tool_name">快递查询</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="box_con mt20 hidden-sm hidden-xs">
            <div class="box_title">
              常用功能
            </div>
            <div class="module_list">
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_1.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">公司核名</div>
                  </div>
                </div>
                <div
                  class="item_btn"
                  @click="golink('http://www.gsxt.gov.cn/index.html')"
                >
                  点击查看
                </div>
              </div>
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_2.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      记账申报
                      <div
                        class="span"
                        @click="addreport"
                        v-if="
                          userinfo.user_type == '4' || userinfo.user_type == '6'
                        "
                      >
                        立即申报
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="report">点击查看</div>
              </div>
              <div class="module_item">
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_3.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      资料寄送
                      <div class="span" @click="adddelivery">立即寄送</div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="delivery">点击查看</div>
              </div>
              <div
                class="module_item"
                v-if="
                  userinfo.user_type == '1' ||
                    userinfo.user_type == '4' ||
                    userinfo.user_type == '6'
                "
              >
                <div class="module_name">
                  <div class="name_icon">
                    <img :src="imgURL + 'user/icon_7_4.png'" />
                  </div>
                  <div class="name_info">
                    <div class="name_title">
                      代开票申请
                      <div
                        v-if="
                          userinfo.user_type == '1' || userinfo.user_type == '6'
                        "
                        class="span"
                        @click="addinvoice"
                      >
                        申请开票
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item_btn" @click="record">点击查看</div>
              </div>
            </div>
          </div>
          <div class="box_con mt20  hidden-sm hidden-xs">
            <div class="box_title">
              常用工具
            </div>
            <div class="tool_list">
              <div
                class="tool_item"
                @click="golink('http://sbj.cnipa.gov.cn/sbcx/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_1.png'" />
                </div>
                <div class="tool_name">商标查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('http://cpquery.cnipa.gov.cn/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_2.png'" />
                </div>
                <div class="tool_name">专利查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('https://register.ccopyright.com.cn/query.html')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_3.png'" />
                </div>
                <div class="tool_name">著作权查询</div>
              </div>
              <div
                class="tool_item"
                @click="
                  golink(
                    'http://shanghai.chinatax.gov.cn/newxbwz/wzfw/yihushi.jsp'
                  )
                "
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_4.png'" />
                </div>
                <div class="tool_name">税务查询</div>
              </div>
              <div
                class="tool_item"
                @click="golink('https://m.kuaidi100.com/')"
              >
                <div class="tool_icon">
                  <img :src="imgURL + 'user/icon_18_5.png'" />
                </div>
                <div class="tool_name">快递查询</div>
              </div>
            </div>
          </div>
          <div class="box_con" v-if="recommend_list.length > 0">
            <div class="box_title">
              企业必备服务
            </div>
            <div class="recommend-list mt20">
              <div class="swiper_list container-build">
                <div class="swiper-container tuijian">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in listTemp"
                      :key="index"
                    >
                      <div
                        class="recommend-item"
                        v-for="(item, i) in item"
                        :key="i"
                        @click="goproductDetail(item.id)"
                      >
                        <div class="item-title-1">
                          {{ item.title }}
                        </div>
                        <div class="item-title-2">{{ item.subtitle }}</div>
                        <div class="item-price-button">
                          <div class="item-price">
                            <span>￥</span>{{ item.current_price }}
                          </div>
                          <div class="item-button">点击查看</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                  <!-- 如果需要滚动条 -->
                  <!--    <div class="swiper-scrollbar"></div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="index-tel">
            <div class="tel-solgan">公司买卖 比注销更划算</div>
            <div class="tel-input mt20">
              <div class="name-icon"></div>
              <input
                type="text"
                v-model="saleinfo.name"
                placeholder="请输入您的姓名"
              />
            </div>
            <div class="tel-input">
              <div class="tel-icon"></div>
              <input
                type="text"
                v-model="saleinfo.tel"
                placeholder="请输入手机号"
                maxlength="11"
              />
            </div>
            <div class="tel-input">
              <div class="tel-icon"></div>
              <input
                type="text"
                v-model="saleinfo.company_name"
                placeholder="请输入公司名称"
              />
            </div>
            <div class="tel-button" @click="btn_save">立即申请</div>
          </div>
        </div>
      </div>

      <indexbanner :adbannerlist="banner_1" :config="config_1"></indexbanner>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import indexbanner from "@/components/indexbanner.vue";
import headd from "@/components/head";
import sTabs from "@/components/s-tabs";
import sTab from "@/components/s-tab";
import vuescroll from "vuescroll";
import foot from "@/components/foot";

import {
  getuserinfo,
  getcompanySale,
  getkefuchannel,
  getappads,
  getucenterTuijian
} from "../../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "个人中心",
      n: 0,
      imgURL: "../../../../static/",
      current: 0,
      tabs: ["基本信息", "股东信息", "证照下载"],
      banners: [
        {
          id: 1,
          img: "../../../../static/user/icon_6.png"
        }
      ],
      texts: "测试数据",
      recommend_list: [],
      userinfo: {},
      saleinfo: {
        name: "",
        tel: "",
        company_name: ""
      },
      banner_1: [],
      config_1: false,
      activeName: "1",
      ops: {
        vuescroll: {
          wheelScrollDuration: 0,
          wheelDirectionReverse: false,
          locking: true,
          checkShifKey: true
        }
      }
    };
  },
  components: {
    indexbanner,
    headd,
    sTabs,
    sTab,
    vuescroll,
    foot
  },
  computed: {
    listTemp: function() {
      let index = 0;
      let count = 4;
      let arrTemp = [];
      let experts = this.recommend_list;
      for (let i = 0; i < this.recommend_list.length; i++) {
        index = parseInt(i / count);
        if (arrTemp.length <= index) {
          arrTemp.push([]);
        }
        arrTemp[index].push(experts[i]);
      }
      return arrTemp;
    }
  },
  mounted() {
    this.userinfolist();
    this.getappads();
    this.recommendlist();
  },
  methods: {
    swiper_tuijian() {
      new Swiper(".tuijian", {
        //loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000,
        slidesPerView: 1
      });
    },
    async recommendlist() {
      var _self = this;
      const res = await getucenterTuijian();
      _self.recommend_list = res.data.data.ucenterTjCombo;
      _self.$nextTick(function() {
        _self.swiper_tuijian();
      });
    },
    async getkefuchannel() {
      var _self = this;
      var data = { uid: localStorage.getItem("userId") };
      const res = await getkefuchannel(data);

      console.log(res);
      if (res.data.status == 1) {
        //_self.kfid = res.data.data.kfid
        return res.data.data.kfid;
      }
    },
    change(index) {
      //console.log('change:', index);
    },
    kefu(recipient) {
      var uid = localStorage.getItem("userId");
      var _self = this;
      var recipient_id = recipient;
      if (recipient_id == 0) {
        console.log(recipient_id);
        _self.getkefuchannel().then(function(result) {
          console.log(result);
          recipient_id = result;
          this.$router.push({
            path: "chat",
            query: {
              uid: uid,
              recipient_id: recipient_id
            }
          });
        });
      } else {
        this.$router.push({
          path: "chat",
          query: {
            uid: uid,
            recipient_id: recipient_id
          }
        });
      }
    },
    async getappads() {
      var _self = this;

      const res = await getappads("ucenter_ads");

      _self.banner_1 = res.data.data.appads;
    },
    changeTab(e) {
      var _self = this;
      //console.log('当前选中的项：' + e)
      _self.current = parseInt(e);
    },
    gocoupon() {
      this.$router.push({
        path: "coupon"
      });
      //   uni.navigateTo({
      //     url: "../../coupon/coupon"
      //   });
    },
    goset() {
      this.$router.push({
        path: "personal"
      });
      //   uni.navigateTo({
      //     url: "../personal/personal"
      //   });
    },
    goSettled() {
      this.$router.push({
        path: "settled"
      });
    },
    goorderlist(index) {
      //   uni.navigateTo({
      //     url: "../../order/order_list"
      //   });
      this.$router.push({
        path: "order_list",
        query: {
          index: index
        }
      });
    },
    gologolist(index) {
      this.$router.push({
        path: "logolist"
      });
    },
    goaffairs() {
      this.$router.push({
        path: "affairs"
      });
    },
    goservice() {
      this.$router.push({
        path: "service"
      });
    },
    gofwzx() {
      this.$router.push({
        path: "fwzm"
      });
    },
    gologo() {
      this.$router.push({
        path: "logo"
      });
    },
    goOrdermange() {
      uni.navigateTo({
        url: "../../order/order_list_manage"
      });
    },
    goView(urlnew) {
      let url = urlnew;
      //console.log(url);
      window.open(url);
      //   this.$refs.lFile.download(url, "local").then(path => {
      //     console.log(path);
      //     this.localPath = path;
      //     this.$refs.lFile.open(path);
      //   });
    },
    goView_image(url) {
      //let url = urlnew;
      window.open(url);
      //   uni.downloadFile({
      //     url: url,
      //     success: res => {
      //       if (res.statusCode === 200) {
      //         uni.saveImageToPhotosAlbum({
      //           filePath: res.tempFilePath,
      //           success: function() {
      //             uni.showToast({
      //               title: "保存成功",
      //               icon: "none"
      //             });
      //           },
      //           fail: function() {
      //             uni.showToast({
      //               title: "保存失败， 请稍后重试",
      //               icon: "none"
      //             });
      //           }
      //         });
      //       }
      //     }
      //   });
    },
    report() {
      var _self = this;
      var type = _self.userinfo.user_type;
      if (type == 1) {
        this.$router.push({
          path: "report"
        });
      } else {
        this.$router.push({
          path: "report_manage"
        });
      }
    },
    gorecharge() {
      this.$router.push({
        path: "rechargelist"
      });
    },

    async userinfolist() {
      var _self = this;

      //   const res = await this.$myRuquest({
      //     url: "/ucenter",
      //     method: "GET",
      //     data: {
      //       uid: uni.getStorageSync("userinfo").id
      //     }
      //   });
      var data = {
        uid: localStorage.getItem("userId")
      };
      const res = await getuserinfo(data);
      //console.log(res)
      _self.userinfo = res.data.data;
    },
    goproductDetail(id) {
      //console.log(id)
      this.$router.push({
        path: "productdetail",
        query: {
          id: id
        }
      });
    },
    adddelivery() {
      this.$router.push({
        path: "adddelivery"
      });
    },
    addreport() {
      this.$router.push({
        path: "add_report"
      });
    },
    delivery() {
      this.$router.push({
        path: "deliverylist"
      });
    },
    goOrderManage(service) {
      this.$router.push({
        path: "order_list_manage",
        query: {
          service: service
        }
      });
    },
    addinvoice() {
      this.$router.push({
        path: "invoice"
      });
    },
    record() {
      var _self = this;
      var type = _self.userinfo.user_type;
      if (type == 1) {
        this.$router.push({
          path: "record"
        });
      } else {
        this.$router.push({
          path: "record_manage"
        });
      }
    },
    getname(e) {
      var that = this;
      that.setValue(e.detail.value, "name");
    },
    gettel(e) {
      var that = this;
      that.setValue(e.detail.value, "tel");
    },
    getcompany_name(e) {
      var that = this;
      that.setValue(e.detail.value, "company_name");
    },
    setValue(v, key) {
      var that = this;
      var tmpData = that.saleinfo;
      tmpData[key] = v;
      that.saleinfo = tmpData;
    },
    async btn_save() {
      var _self = this;
      var data = _self.saleinfo;
      var phone_reg = /^1[3456789]\d{9}$/;

      if (data.name == "") {
        this.$toast("请输入名称");
        return false;
      }

      if (data.tel == "") {
        this.$toast("请输入电话");
        return false;
      } else {
        if (!phone_reg.test(data.tel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }
      if (data.company_name == "") {
        this.$toast("请输入公司名称");
        return false;
      }

      var parm = {
        uid: localStorage.getItem("userId"),
        name: data.name,
        tel: data.tel,
        company_name: data.company_name
      };

      const res = await getcompanySale(parm);

      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.saleinfo.name = "";
        _self.saleinfo.tel = "";
        _self.saleinfo.company_name = "";
      }
    },
    gotwitter() {
      //console.log(2)
      this.$router.push({
        path: "twitter"
      });
    },
    // goorderlist(index) {
    //   uni.navigateTo({
    //     url: "../../order/order_list?index=" + index
    //   });
    // },
    goagency() {
      this.$router.push({
        path: "agency"
      });
    },
    golink(url) {
      window.open(url, "_blank");
    }
  },
  onShow: function() {
    var _self = this;
    _self.userinfo = {
      balance: 0,
      avatarUrl: "../../../static/user/icon_1.png",
      couponNum: 0
    };
    // if (uni.getStorageSync("sessionToken")) {
    //   _self.recommendlist();
    //   _self.userinfolist();
    //   _self.$logindex();
    //   _self.getappads();
    // } else {
    //   uni.navigateTo({
    //     url: "../../login/login/login"
    //   });
    // }
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
  align-items: flex-start;
  padding-bottom: 0.6rem;
}
.userinfo {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
    .container {
      padding: 0;
    }
  }
}

.user_index {
  flex-direction: column;

  .user_head {
    position: relative;
    width: 100%;
    height: 2.71rem;
    overflow: hidden;
    padding-top: 0rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    flex-direction: row;
    background-color: #fff;
    border: 0.01rem solid #ccc;
    display: flex;

    .head_set {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      width: 0.38rem;
      height: 0.42rem;
      z-index: 12;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .head_info {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .headi {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .avtar {
          margin-left: 0.32rem;
          margin-top: 0.32rem;
          width: 1.26rem;
          height: 1.26rem;
          margin-right: 0.3rem;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .info {
          flex-direction: column;
          display: flex;
          margin-top: 0.26rem;
          .name {
            font-size: 0.26rem;
            color: #1b1c33;
            line-height: 0.37rem;
            margin-bottom: 0.1rem;
          }

          .mobile {
            display: flex;
            .m_icon {
              width: 0.12rem;
              height: 0.2rem;

              img {
                width: 100%;
                height: 100%;
              }

              margin-right: 0.1rem;
            }

            font-size: 0.24rem;
            color: #5e5e66;
            line-height: 0.33rem;
          }
        }
      }
    }

    .head_tab {
      justify-content: space-evenly;
      display: flex;
      width: 50%;
      position: relative;
      margin-top: 0.53rem;
      .tab_title {
        position: absolute;
        top: 0rem;
        left: 0.75rem;
        font-size: 0.26rem;
        line-height: 0.37rem;
        color: #1b1c33;
      }
      .tab_item {
        flex: 1;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        position: relative;
        display: flex;
        cursor: pointer;

        .tab_count {
          height: 0.42rem;
          font-size: 0.3rem;
          font-weight: bolder;
          color: #ff545a;
          line-height: 0.42rem;
          margin-bottom: 0.1rem;
          text-align: center;
          justify-content: center;
        }

        .tab_name {
          height: 0.25rem;
          font-size: 0.18rem;
          color: #5e5e66;
          line-height: 0.25rem;
          text-align: center;
          justify-content: center;
        }

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          margin-top: -0.29rem;
          right: 0;
          width: 0.02rem;
          height: 0.58rem;
          background: rgba(196, 196, 204, 1);
        }

        &:last-child {
          &::after {
            width: 0;
          }
        }
      }
    }

    .head_type {
      width: 4.81rem;
      margin: 0.32rem 0.32rem 0 0rem;
      display: flex;
      height: 0.96rem;
      background: url(../../../../static/user/icon_4_1.png) no-repeat;
      background-size: 4.81rem 0.96rem;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.15rem 0 0.31rem;

      .type_name {
        align-items: center;
        display: flex;

        .name_icon {
          width: 0.26rem;
          height: 0.32rem;
          margin-right: 0.22rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        font-size: 0.26rem;
        color: #ffe1a6;
      }

      .type_more {
        cursor: pointer;
        width: 1rem;
        height: 0.3rem;
        background: #ffe1a6;
        border-radius: 0.15rem;
        font-size: 0.18rem;
        line-height: 0.3rem;
        color: #313f75;
        justify-content: center;
        align-items: center;
      }
    }

    @media (max-width: 991px) {
      position: relative;
      width: 100%;
      height: 3.64rem;
      overflow: hidden;
      //   padding-top: 1.29rem;
      flex-direction: column;
      background-color: #ffffff;
      display: flex;
      border: 0;

      .head_set {
        position: absolute;
        top: 0.37rem;
        right: 0.32rem;
        width: 0.38rem;
        height: 0.42rem;
        display: flex;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .head_info {
        align-items: center;
        margin-bottom: 0.4rem;
        display: flex;
        flex-direction: row;

        .avtar {
          margin-left: 0.32rem;
          width: 1.26rem;
          height: 1.26rem;
          margin-right: 0.3rem;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .info {
          flex-direction: column;
          display: flex;

          .name {
            font-size: 0.36rem;
            height: 0.5rem;
            color: #1b1c33;
            line-height: 0.5rem;
            margin-bottom: 0.05rem;
            display: flex;
          }

          .mobile {
            display: flex;

            .m_icon {
              width: 0.2rem;
              height: 0.31rem;

              img {
                width: 100%;
                height: 100%;
              }

              margin-right: 0.1rem;
            }

            height: 0.4rem;
            font-size: 0.28rem;

            color: #5e5e66;
            line-height: 0.4rem;
          }
        }
      }

      .head_tab {
        justify-content: space-evenly;
        display: flex;
        width: 100%;
        margin-top: 0;

        .tab_item {
          flex: 1;
          flex-direction: column;
          text-align: center;
          justify-content: center;
          position: relative;

          .tab_count {
            height: 0.5rem;
            font-size: 0.36rem;
            font-weight: bolder;
            color: #ff545a;
            line-height: 0.5rem;
            margin-bottom: 0.05rem;
            text-align: center;
            justify-content: center;
          }

          .tab_name {
            height: 0.33rem;
            font-size: 0.26rem;
            color: #5e5e66;
            line-height: 0.33rem;
            text-align: center;
            justify-content: center;
          }

          &::after {
            content: "";
            position: absolute;
            top: 50%;
            margin-top: -0.29rem;
            right: 0;
            width: 0.02rem;
            height: 0.58rem;
            background: rgba(196, 196, 204, 1);
          }

          &:last-child {
            &::after {
              width: 0;
            }
          }
        }
      }

      .head_type {
        margin: 0.32rem 0 0 0;
        width: 6.86rem;
        height: 0.79rem;
        background: url(../../../../static/user/icon_4_1.png) no-repeat;
        background-size: cover;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.15rem 0 0.31rem;

        .type_name {
          align-items: center;

          .name_icon {
            width: 0.3rem;
            height: 0.37rem;
            margin-right: 0.2rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          font-size: 0.3rem;

          font-weight: 600;
          color: #ffe1a6;
        }

        .type_more {
          width: 1.26rem;
          height: 0.4rem;
          line-height: 0.4rem;
          background: #ffe1a6;
          border-radius: 0.2rem;
          font-size: 0.24rem;
          color: #313f75;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

.box_con {
  padding: 0.2rem 0.24rem;
  background: #fff;
  border: 0.01rem solid #ccc;
  border-radius: 0rem;
  margin: 0 auto 0.2rem auto;
  flex-direction: column;
  width: auto;

  .box_title {
    font-size: 0.24rem;
    display: flex;
    color: #1b1c33;
    line-height: 0.33rem;
    justify-content: space-between;
    width: 100%;
    @media (max-width: 991px) {
      height: 0.42rem;
      font-size: 0.3rem;

      color: #1b1c33;
      line-height: 0.42rem;
      justify-content: space-between;
      width: 100%;
    }

    .more {
      font-size: 0.24rem;
      color: #8d8e99;
      background: url(../../../../static/user/icon_8.png) center right no-repeat;
      background-size: 0.12rem 0.22rem;
      padding-right: 0.28rem;
    }
  }

  .order_status {
    width: 100%;
    justify-content: space-around;
    margin-top: 0.3rem;
    display: flex;

    .status_item {
      flex-direction: column;
      cursor: pointer;

      .item_icon {
        width: 0.6rem;
        height: 0.52rem;
        margin: 0 auto 0.16rem auto;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }
        .tip {
          position: absolute;
          top: -0.1rem;
          right: -0.1rem;
          padding: 0.05rem;
          width: 0.24rem;
          height: 0.24rem;
          border-radius: 50%;
          background-color: #ff545a;
          font-size: 0.13rem;
          line-height: 0.14rem;
          color: #ffffff;
          text-align: center;
          justify-content: center;
        }
      }

      .item_name {
        font-size: 0.2rem;
        color: #1b1c33;
        height: 0.25rem;
        line-height: 0.25rem;
      }
    }
    @media (max-width: 991px) {
      width: 100%;
      justify-content: space-around;
      margin-top: 0.3rem;

      .status_item {
        flex-direction: column;

        .item_icon {
          width: 0.6rem;
          height: 0.52rem;
          margin: 0 auto 0.16rem auto;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }
          .tip {
            position: absolute;
            top: -0.15rem;
            right: -0.15rem;
            width: auto;
            padding: 0.05rem;
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            background-color: #ff545a;
            font-size: 0.2rem;
            line-height: 0.3rem;
            color: #ffffff;
            text-align: center;
            justify-content: center;
          }
        }

        .item_name {
          font-size: 0.26rem;
          color: #1b1c33;
          height: 0.33rem;
          line-height: 0.33rem;
        }
      }
    }
  }

  .service {
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    .service_item {
      width: 2.8rem;
      height: 1.66rem;
      background: #f8f9fd;
      border-radius: 0.1rem;
      flex-direction: column;
      margin-top: 0.1rem;
      margin-bottom: 0.2rem;

      .item_head {
        width: 100%;
        height: 0.63rem;
        border-bottom: 0.02rem solid rgba(196, 196, 204, 0.2);
        font-size: 0.2rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        display: flex;

        .head_icon {
          width: 0.26rem;
          height: 0.26rem;
          margin-right: 0.05rem;

          img {
            width: 100%;
          }
        }
      }

      .item_con {
        height: 1rem;
        align-items: center;
        justify-content: center;
        font-size: 0.4rem;
        font-weight: bolder;
        color: #1395ff;
        letter-spacing: 0.01rem;
        text-align: center;
        cursor: pointer;
      }

      &:nth-child(7) {
        width: 100%;
      }
    }
    @media (max-width: 991px) {
      flex-wrap: wrap;
      justify-content: space-between;

      .service_item {
        width: 3.09rem;
        height: 1.66rem;
        background: #f8f9fd;
        border-radius: 0.1rem;
        flex-direction: column;
        margin-bottom: 0.2rem;

        .item_head {
          width: 100%;
          height: 0.63rem;
          border-bottom: 0.02rem solid rgba(196, 196, 204, 0.2);
          font-size: 0.28rem;

          color: #1b1c33;
          align-items: center;
          justify-content: center;

          .head_icon {
            width: 0.26rem;
            height: 0.26rem;
            margin-right: 0.05rem;
            display: flex;
            align-items: center;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .item_con {
          height: 1rem;
          align-items: center;
          justify-content: center;
          font-size: 0.4rem;

          font-weight: bolder;
          color: #1395ff;
          letter-spacing: 0.01rem;
        }

        &:nth-child(7) {
          width: 100%;
        }
      }
    }
  }

  .module_list {
    padding: 0;
    width: 100%;
    flex-direction: column;

    .module_item {
      width: auto;
      padding: 0 0.2rem 0 0.24rem;
      height: 0.7rem;
      margin-top: 0.2rem;
      background: #f8f9fd;
      border-radius: 0.1rem;
      align-items: center;
      justify-content: space-between;
      display: flex;

      .module_name {
        align-items: center;
        display: flex;

        .name_icon {
          width: 0.33rem;
          height: 0.33rem;
          margin-right: 0.19rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .name_info {
          flex-direction: column;

          .name_title {
            height: 0.25rem;
            font-size: 0.16rem;
            color: #5e5e66;
            line-height: 0.25rem;
            display: flex;

            .span {
              color: #1395ff;
              margin-left: 0.2rem;
              cursor: pointer;
            }
          }

          .name_tip {
            font-size: 0.18rem;
            color: #8d8e99;
            line-height: 0.25rem;
            height: 0.25rem;
          }
        }

        height: 0.33rem;
        font-size: 0.24rem;
        color: #5e5e66;
        line-height: 0.33rem;
      }

      .item_btn {
        cursor: pointer;
        width: 0.96rem;
        height: 0.3rem;
        background: #1395ff;
        border-radius: 0.15rem;
        line-height: 0.3rem;
        font-size: 0.14rem;
        color: #ffffff;
        align-items: center;
        justify-content: center;
      }
    }
    @media (max-width: 991px) {
      padding: 0 0;
      width: 6.38rem;
      flex-direction: column;

      .module_item {
        width: 100%;
        padding: 0 0.2rem 0 0.24rem;
        height: 0.9rem;
        margin-top: 0.2rem;
        background: #f8f9fd;
        border-radius: 0.1rem;
        align-items: center;
        justify-content: space-between;

        .module_name {
          align-items: center;

          .name_icon {
            width: 0.5rem;
            height: 0.5rem;
            margin-right: 0.19rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .name_info {
            flex-direction: column;

            .name_title {
              height: 0.33rem;
              font-size: 0.28rem;

              color: #5e5e66;
              line-height: 0.33rem;

              .span {
                color: #1395ff;
                margin-left: 0.2rem;
              }
            }

            .name_tip {
              font-size: 0.18rem;

              color: #8d8e99;
              line-height: 0.25rem;
              height: 0.25rem;
            }
          }

          height: 0.33rem;
          font-size: 0.24rem;
          color: #5e5e66;
          line-height: 0.33rem;
        }

        .item_btn {
          width: 1.36rem;
          height: 0.4rem;
          background: #1395ff;
          border-radius: 0.2rem;
          line-height: 0.4rem;
          font-size: 0.26rem;
          color: #ffffff;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .info_data {
    flex-direction: column;
    text-align: left;
    .data_head {
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.07rem;
      padding: 0;

      .data_title {
        height: 0.33rem;
        font-size: 0.2rem;
        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.33rem;
        align-items: center;

        .line {
          width: 0.05rem;
          height: 0.26rem;
          background: #1395ff;
          border-radius: 0.03rem;
          margin-right: 0.05rem;
        }
      }

      .arrow_right {
        width: 0.3rem;
        height: 0.17rem;

        img {
          width: 0.3rem;
          height: 0.17rem;
        }
      }

      .data_right {
        font-size: 0.16rem;
        color: #8d8e99;
        line-height: 0.25rem;
        display: flex;

        .right {
          margin-left: 0.1rem;
          font-size: 0.15rem;
          color: #ff545a;
        }
      }
    }

    .data_sn {
      height: 0.25rem;
      font-size: 0.18rem;
      color: #1395ff;
      line-height: 0.25rem;
      margin-top: 0.1rem;
      margin-bottom: 0rem;
      margin-left: 0.08rem;
    }

    .data_cell_list {
      flex-direction: column;

      .data_cell {
        padding: 0;
        margin-bottom: 0.16rem;

        .cell_title {
          width: 1rem;
          line-height: 0.25rem;
          height: 0.25rem;
          font-size: 0.16rem;
          color: #1b1c33;
        }

        .cell_con {
          font-size: 0.16rem;
          color: #000;
          font-weight: normal;
          line-height: 0.25rem;
        }
      }
    }

    .data_table_list {
      width: 100%;
      flex-direction: column;

      .table_head {
        height: 0.4rem;
        line-height: 0.4rem;
        font-weight: bolder;
      }

      .head_25 {
        flex: 1;
        font-size: 0.16rem;
        text-align: center;
        height: 0.4rem;
        line-height: 0.4rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 0.01rem solid rgba(196, 196, 204, 0.5);
      }

      .head_50 {
        flex: 2;
        font-size: 0.16rem;
        text-align: center;
        height: 0.4rem;
        line-height: 0.4rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 0.01rem solid rgba(196, 196, 204, 0.5);
        border-left: 0;
        border-right: 0;
      }
    }

    .data_img {
      width: 100%;

      .img_item {
        width: 1.4rem;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          text-align: center;
          width: 1.4rem;
          height: auto;
          vertical-align: middle;
          margin-bottom: 0.2rem;
        }

        .item_btn {
          cursor: pointer;
          width: 0.86rem;
          height: 0.32rem;
          line-height: 0.32rem;
          font-size: 0.14rem;
          text-align: center;
          color: #fff;
          justify-content: center;
          background: #1395ff;
          border-radius: 0.16rem;
        }
      }
    }

    @media (max-width: 991px) {
      flex-direction: column;

      .data_head {
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.07rem;

        .data_title {
          height: 0.4rem;
          font-size: 0.28rem;

          font-weight: bolder;
          color: #1b1c33;
          line-height: 0.4rem;
          align-items: center;

          .line {
            width: 0.05rem;
            height: 0.26rem;
            background: #1395ff;
            border-radius: 0.03rem;
            margin-right: 0.05rem;
          }
        }

        .arrow_right {
          width: 0.3rem;
          height: 0.17rem;

          img {
            width: 0.3rem;
            height: 0.17rem;
          }
        }

        .data_right {
          font-size: 0.26rem;

          color: #8d8e99;
          line-height: 0.3rem;

          .right {
            margin-left: 0.1rem;
            font-size: 0.28rem;
            color: #ff545a;
          }
        }
      }

      .data_sn {
        height: 0.3rem;
        font-size: 0.26rem;

        color: #1395ff;
        line-height: 0.3rem;
        margin-top: 0.1rem;
        margin-bottom: 0.2rem;
        margin-left: 0.08rem;
      }

      .data_cell_list {
        flex-direction: column;

        .data_cell {
          padding: 0rpx;
          margin-bottom: 0.2rem;

          .cell_title {
            width: 1.66rem;
            line-height: 0.33rem;
            height: 0.33rem;
            font-size: 0.26rem;

            color: #1b1c33;
          }

          .cell_con {
            width: 4.5rem;
            font-size: 0.26rem;

            color: #1b1c33;
            line-height: 0.33rem;
          }
        }
      }

      .data_table_list {
        width: 6.38rem;
        flex-direction: column;

        .table_head {
          height: 0.77rem;
          line-height: 0.77rem;
          font-weight: 600;
        }

        .head_25 {
          flex: 1;
          font-size: 0.26rem;
          text-align: center;
          height: 0.77rem;
          line-height: 0.77rem;
          color: #1b1c33;
          align-items: center;
          justify-content: center;
          background-color: #f2f2f2;
          border: 1rpx solid rgba(196, 196, 204, 0.5);
        }

        .head_50 {
          flex: 2;
          font-size: 0.26rem;
          text-align: center;
          height: 0.77rem;
          line-height: 0.77rem;
          color: #1b1c33;
          align-items: center;
          justify-content: center;
          background-color: #f2f2f2;
          border: 0.01rem solid rgba(196, 196, 204, 0.5);
          border-left: 0;
          border-right: 0;
        }
      }

      .data_img {
        width: 100%;

        .img_item {
          width: 2.4rem;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            text-align: center;
            width: 2.4rem;
            height: auto;
            vertical-align: middle;
            margin-bottom: 0.2rem;
          }

          .item_btn {
            width: 1.26rem;
            height: 0.4rem;
            line-height: 0.4rem;
            font-size: 0.24rem;
            text-align: center;
            color: #fff;
            justify-content: center;
            background: #1395ff;
            border-radius: 0.2rem;
          }
        }
      }
    }
  }
}
/*webkit内核*/
.scroll_content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.recommend-list {
  height: 5.38rem;
  overflow: hidden;
  flex-direction: column;
  flex-wrap: wrap;
  width: auto;
  overflow-x: auto;
  display: flex;

  .recommend-item {
    width: 1.9rem;
    height: 2.29rem;
    float: left;
    background: url(../../../../static/index/recommend/recommend-item-bg-1-1.png)
      bottom center no-repeat;
    background-size: 100%;
    flex-direction: column;
    padding: 0.3rem 0;
    margin-top: 0.15rem;
    margin-bottom: 0.2rem;
    margin-right: 0.2rem;
    display: flex;
    align-items: center;
    border: 1px solid #f2f2f2;
    border-radius: 0.12rem;

    .item-title-1 {
      font-size: 0.2rem;
      line-height: 0.25rem;
      color: #1b1c33;
      font-weight: bolder;
      margin-bottom: 0.05rem;
    }

    .item-title-2 {
      font-size: 0.16rem;
      color: #5e5e66;
      line-height: 0.25rem;
      margin-bottom: 0.14rem;
    }

    .item-price-button {
      justify-content: space-between;
      align-items: center;
      display: flex;
      flex-direction: column;

      .item-price {
        font-size: 0.36rem;
        color: #ff545a;
        line-height: 0.48rem;
        margin-right: 0.1rem;

        span {
          font-size: 0.16rem;
          line-height: 0.6rem;
        }
      }

      .item-button {
        width: 0.96rem;
        height: 0.3rem;
        font-size: 0.18rem;
        line-height: 0.3rem;
        background-color: #1395ff;
        border-radius: 0.15rem;
        color: #ffffff;
        text-align: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .recommend-item:nth-child(2n) {
    margin-right: 0rem;
  }

  .recommend-item:nth-child(2) {
    background: url(../../../../static/index/recommend/recommend-item-bg-2.png)
      bottom center no-repeat;
    background-size: 100%;

    .item-button {
      background-color: #ff9f35;
    }
  }

  .recommend-item:nth-child(3) {
    background: url(../../../../static/index/recommend/recommend-item-bg-3.png)
      bottom center no-repeat;
    background-size: 100%;

    .item-button {
      background-color: #18e0ac;
    }
  }

  .recommend-item:nth-child(4) {
    background: url(../../../../static/index/recommend/recommend-item-bg-4.png)
      bottom center no-repeat;
    background-size: 100%;

    .item-button {
      background-color: #ff656a;
    }
  }
  @media (max-width: 991px) {
    height: 4.7rem;
    flex-direction: column;
    flex-wrap: wrap;
    overflow-x: auto;
    .recommend-item {
      width: 3.03rem;
      height: 1.98rem;
      background: url(../../../../static/index/recommend/recommend-item-bg-1.png)
        no-repeat;
      background-size: cover;
      flex-direction: column;
      float: left;
      padding: 0.3rem;
      margin-bottom: 0.2rem;
      margin-right: 0.2rem;

      .item-title-1 {
        font-size: 0.28rem;
        line-height: 0.37rem;
        color: #1b1c33;
        font-weight: bolder;
        text-align: left;
        width: 100%;
      }

      .item-title-2 {
        text-align: left;
        font-size: 0.26rem;
        color: #5e5e66;
        line-height: 0.3rem;
        margin-bottom: 0.14rem;
        width: 100%;
      }

      .item-price-button {
        justify-content: space-between;
        align-items: center;
        display: flex;
        flex-direction: row;

        .item-price {
          font-size: 0.48rem;
          color: #ff545a;
          line-height: 0.48rem;
          font-weight: bolder;
          margin-right: 0.1rem;

          span {
            font-size: 0.3rem;
            line-height: 0.6rem;
          }
        }

        .item-button {
          width: 1.26rem;
          height: 0.4rem;
          font-size: 0.24rem;
          line-height: 0.4rem;
          background-color: #1395ff;
          border-radius: 0.2rem;
          color: #ffffff;
          text-align: center;
          justify-content: center;
        }
      }
    }

    .recommend-item:nth-child(2) {
      background: url(../../../../static/index/recommend/recommend-item-bg-2.png)
        no-repeat;
      background-size: cover;

      .item-button {
        background-color: #ff9f35;
      }
    }

    .recommend-item:nth-child(3) {
      background: url(../../../../static/index/recommend/recommend-item-bg-3.png)
        no-repeat;
      background-size: cover;

      .item-button {
        background-color: #18e0ac;
      }
    }

    .recommend-item:nth-child(4) {
      background: url(../../../../static/index/recommend/recommend-item-bg-4.png)
        no-repeat;
      background-size: cover;

      .item-button {
        background-color: #ff656a;
      }
    }
  }
}

.index-tel {
  margin: 0 auto 0rem auto;
  width: auto;
  height: 4.47rem;
  overflow: hidden;
  background: url(../../../../static/index/tel-box/tel-box-3.png) no-repeat;
  background-size: 100%;
  flex-direction: column;
  padding: 0 0.3rem;

  .tel-solgan {
    margin-top: 0.3rem;
    font-size: 0.26rem;
    line-height: 0.33rem;
    height: 0.33rem;
    color: #1395ff;
    text-align: center;
    justify-content: center;
    margin-bottom: 0.24rem;
    @media (max-width: 991px) {
      font-size: 0.32rem;
      line-height: 0.42rem;
    }
  }

  .tel-solgan-2 {
    line-height: 0.33rem;
    height: 0.33rem;
    font-size: 0.2rem;
    color: #1b1c33;
    text-align: center;
    justify-content: center;
    margin-bottom: 0.24rem;

    span {
      font-size: 0.24rem;
      color: #ff545a;
    }
  }

  .tel-input {
    margin: 0 auto 0.2rem auto;
    width: auto;
    height: 0.6rem;
    background: #fff;
    border-radius: 0.3rem;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 0.3rem;
    display: flex;

    input {
      width: 100%;
      height: 100%;
      font-size: 0.16rem;
      border: none;
      @media (max-width: 991px) {
        font-size: 0.26rem;
      }
    }

    .name-icon {
      width: 0.28rem;
      height: 0.32rem;
      background: url(../../../../static/index/tel-box/name-icon.png) no-repeat;
      background-size: 100%;
      margin-right: 0.2rem;
    }

    .tel-icon {
      width: 0.25rem;
      height: 0.4rem;
      background: url(../../../../static/index/tel-box/tel-icon.png) no-repeat;
      background-size: 100%;
      margin-right: 0.2rem;
    }
  }

  .tel-button {
    margin: 0 auto;
    width: auto;
    height: 0.6rem;
    background: #1395ff;
    border-radius: 0.3rem;
    text-align: center;
    line-height: 0.6rem;
    font-size: 0.24rem;
    color: #ffffff;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.32rem;
    }
  }
}

.index-banner {
  width: 100%;
  height: auto !important;
  margin: auto;
  margin-bottom: 0.2rem;

  img {
    width: 100%;
  }
}
.index-banner.container {
  padding: 0;
}

.tool_list {
  width: 100%;
  justify-content: space-between;
  margin-top: 0.3rem;
  flex-wrap: wrap;
  display: flex;

  .tool_item {
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    // width: 120rpx;
    margin-bottom: 0.3rem;
    display: flex;

    .tool_icon {
      width: 0.4rem;
      height: 0.4rem;
      margin: 0 auto 0.16rem auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .tool_name {
      font-size: 0.16rem;
      color: #5e5e66;
      line-height: 0.25rem;
    }
  }

  &::after {
    content: "";
    width: 2rem;
  }
  @media (max-width: 991px) {
    width: 100%;
    justify-content: space-between;
    margin-top: 0.3rem;
    flex-wrap: wrap;

    .tool_item {
      flex-direction: column;
      align-items: center;
      // width: 120rpx;
      margin-bottom: 0.3rem;

      .tool_icon {
        width: 0.5rem;
        height: 0.5rem;
        margin: 0 auto 0.16rem auto;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .tool_name {
        font-size: 0.26rem;
        color: #5e5e66;
        line-height: 0.33rem;
      }
    }

    &::after {
      content: "";
      width: 2rem;
    }
  }
}
.btn_list {
  justify-content: space-around;
  display: flex;
  flex-wrap: wrap;

  .bbtn {
    width: 2.7rem;
    height: 0.7rem;
    font-size: 0.24rem;
    color: #ffffff;
    line-height: 0.7rem;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    text-align: center;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }

  .bbtn.btnzx {
    background-color: #1395ff;
  }

  .bbtn.btngm {
    background-color: #f4556c;
  }
}
.dlogo {
  flex-direction: column;

  .logoimg {
    width: 1.4rem;
    height: 1.4rem;
    background-position: center;
    background-size: cover;
    overflow: hidden;
    margin-bottom: 0.2rem;
    img {
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    @media (max-width: 991px) {
      width: 2.4rem;
      height: 2.4rem;
    }
  }
  .item_btn {
    margin-left: 0.3rem;
    cursor: pointer;
    width: 0.86rem;
    height: 0.32rem;
    line-height: 0.32rem;
    font-size: 0.14rem;
    text-align: center;
    color: #fff;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background: #1395ff;
    border-radius: 0.16rem;
    @media (max-width: 991px) {
      margin-left: 0.6rem;
      width: 1.26rem;
      height: 0.4rem;
      line-height: 0.4rem;
      font-size: 0.24rem;
      border-radius: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/index/index.vue